<template>
  <div>
    <v-stepper-step :complete="step > 2" step="2">
      Review
    </v-stepper-step>

    <v-stepper-content step="2">
      <v-row>
        <v-col cols="12">
          <v-sheet>
            <v-card-text>
              <h2>
                Summary
              </h2>
              <p>
                <strong>{{ promo.name }}</strong> - <i>{{ promo.description }}</i><br/>
                <strong>Amount:</strong> {{ moneyFormat(amount) }}
              </p>
              <p>Your service will renew <b>{{ renewalterm }}</b> for <b>{{ moneyFormat(renewalrate) }}</b>, starting on <b>{{ renewaldate }}</b>.
              <br/><br/>
              <h2>
                Payment Information
              </h2>
              <p>Please confirm your payment information.</p>
              <payment-gateway
                compact
                ref="paymentGateway"
                @card-switch="cardSwitch"
                @card="setCard"
              />

              <v-checkbox
                label="I agree to the pricing above and approve this charge."
                v-model="confirm"
              ></v-checkbox>

              <gg-btn
                color="primary"
                tile elevation="0"
                :disabled="!confirm"
                :loading="loading"
                @click="submit"
              >
                Submit
              </gg-btn>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PaymentGateway from 'Components/Common/PaymentGateway'
import { isEmpty, moneyFormat } from 'Helpers/helpers'

export default {
  name: 'PromoStepTwo',
  props: {
    step: {
      type: Number,
      required: true
    },
    service: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    PaymentGateway
  },
  data: () => ({
    confirm: false,
    isNewCard: false,
    loading: false,
    model: {
      payment_method: '',
      payment_cvv: 0,
      payment_cardnum: 0,
      payment_expdate: 0
    }
  }),
  computed: {
    ...mapGetters(['promo', 'promoServices', 'SessionProfile']),
    creditCard () {
      switch (this.isNewCard) {
        case true:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.model.payment_cvv,
            payment_cardnum: this.model.payment_cardnum,
            payment_expdate: this.model.payment_expdate
          }
        case false:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.model.payment_cvv,
          }
        default:
          return {
            payment_method: 'creditcard',
            payment_cvv: this.model.payment_cvv,
          }
      }
    },
    amount () {
      if (isEmpty(this.service)) {
        return ''
      } else {
        const service_id = this.service.id
        return this.promoServices.find(service => service.service_id === +service_id).payment_amount
      }
    },
    renewaldate () {
      if (isEmpty(this.service)) {
        return ''
      } else {
        const service_id = this.service.id
        return this.promoServices.find(service => service.service_id === +service_id).next_due_date
      }
    },
    renewalrate () {
      if (isEmpty(this.service)) {
        return ''
      } else {
        const service_id = this.service.id
        return this.promoServices.find(service => service.service_id === +service_id).renewal_rate
      }
    },
    renewalterm () {
      if (isEmpty(this.service)) {
        return ''
      } else {
        const service_id = this.service.id
        return this.promoServices.find(service => service.service_id === +service_id).renewal_term
      }
    }
  },
  methods: {
    ...mapActions(['submitPromo', 'reportSuccess', 'reportError']),
    moneyFormat,
    cardSwitch (val) {
      this.isNewCard = val
    },
    setCard (val) {
      this.model.payment_cvv = val.cardnum_cvv
      this.model.payment_cardnum = val.cardnum
      this.model.payment_expdate = val.expdate
    },
    async submit () {
      try {
        const valid = await this.$refs.paymentGateway.validateForm()

        if (!valid) return

        this.loading = true
        const data = {
          promo_id: this.$route.params.promo_id,
          service: this.service.id,
          payment_amount: this.amount,
        }

        const response = await this.submitPromo({ ...data, ...this.creditCard })
        this.reportSuccess(response.resultmsg)
        this.$emit('promo-submitted', response)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  }
}
</script>
